import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"],
    _excluded2 = ["styles", "content", "closeTriggerElement"],
    _excluded3 = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useRef, useMemo, useCallback } from 'react';
import classNames from 'classnames';
import { OverlayTrigger } from '../Overlay/index.js';
import { applyStylingHoc } from '../../lib/styling.js';
import baseStyles from './Tooltip.scss';

var OverlayWrapper = function OverlayWrapper(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return children(rest);
};

var defaultProps = {
  trigger: ['hover', 'focus'],
  styles: {}
};
/**
 * A Tooltip
 */

export var Tooltip = function Tooltip(props) {
  var styles = props.styles,
      content = props.content,
      CloseTriggerElement = props.closeTriggerElement,
      rest = _objectWithoutProperties(props, _excluded2); // REF: TS: get rid of any


  var _overlay = useRef();

  var handleClose = useCallback(function () {
    if (_overlay.current) {
      // @ts-ignore
      _overlay.current.hide();
    }
  }, [_overlay]);
  var overlayStyle = useMemo(function () {
    return {
      minWidth: rest.minWidth || 'initial'
    };
  }, [rest.minWidth]);
  return (// @ts-ignore
    React.createElement(OverlayTrigger, _objectSpread(_objectSpread({}, rest), {}, {
      // @ts-ignore
      ref: _overlay,
      overlay: React.createElement(OverlayWrapper, null, function (_ref2) {
        var className = _ref2.className,
            thisRest = _objectWithoutProperties(_ref2, _excluded3);

        return React.createElement("div", _objectSpread({
          className: classNames(className, styles.root, rest.placement && styles[rest.placement], rest.inverted && styles['is-inverted'], rest.color && styles['is-' + rest.color], _defineProperty({}, styles['in'], !rest.animation))
        }, thisRest), React.createElement("div", {
          className: styles.arrow
        }), React.createElement("div", {
          className: styles.content,
          style: overlayStyle
        }, CloseTriggerElement && React.createElement(CloseTriggerElement, {
          handleClose: handleClose
        }), content));
      })
    }))
  );
};
Tooltip.defaultProps = defaultProps;
export default applyStylingHoc(baseStyles)(Tooltip);